export const SET_USER = "SET_USER";

export const setUser = (payload) => ({payload, type: SET_USER});
